'use client';

import React from 'react'

// Components
import ListListingOfficeTemplate from "@src/components/templates/list-listing-office";

const Page = () => {
  return (<ListListingOfficeTemplate />)
}

export default Page